interface WizardProgressProps {
  step: number;
  isManga: boolean;
  isUkiyo: boolean;
  totalSteps?: number;
}

export function WizardProgress({ step, isManga, isUkiyo, totalSteps = 5 }: WizardProgressProps) {
  const steps = Array.from({ length: totalSteps }, (_, i) => i);

  if (isManga) {
    return (
      <div className="flex gap-0.5 mb-4">
        {steps.map(i => (
          <div key={i} className={`h-2 flex-1 ${
            i === step
              ? 'bg-[#0a0a0a] border border-[#0a0a0a]'
              : i < step
                ? 'bg-[#0a0a0a]'
                : 'bg-[#f0ebe2] border border-[#0a0a0a]'
          }`} />
        ))}
      </div>
    );
  }

  if (isUkiyo) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 16, justifyContent: 'center', paddingTop: 14 }}>
        {steps.map(i => (
          <div key={i} style={{
            width: i === step ? 28 : 8, height: 6,
            borderRadius: i === step ? 3 : 50,
            background: i === step ? '#1B5C8A' : i < step ? '#B8860B' : 'rgba(27,79,138,0.18)',
            transition: 'all 0.3s',
          }} />
        ))}
      </div>
    );
  }

  return null;
}
